<template>
  <Wrapper :canCancel="!!rejectLabel" class="dialog" @cancel="cancel">
    <template #header>
      <div class="title">
        {{ title }}
      </div>
    </template>
    <div class="message">{{ message }}</div>
    <template #footer>
      <div class="footer">
        <button v-if="rejectLabel" class="icon-button cancel" @click="cancel">
          {{ rejectLabel }}
        </button>
        <button v-if="resolveLabel" class="icon-button" @click="close">
          {{ resolveLabel }}
        </button>
      </div>
    </template>
  </Wrapper>
</template>

<script>
import Wrapper from '@/services/dialogs/DialogWrapper.vue';
export default {
  name: 'NotificationMessage',
  components: { Wrapper },
  props: {
    title: String,
    message: String,
    resolveLabel: String,
    rejectLabel: String
  },
  methods: {
    cancel(e) {
      this.$emit('cancel', e);
    },
    close(e) {
      this.$emit('hide', e);
    }
  }
};
</script>

<style scoped>
.icon-button {
  width: 100px;
  height: 35px;
  border-radius: 100px;
  text-transform: uppercase;
  margin: 10px;
}

.cancel {
  background: transparent;
  border: none;
  color: #000;
}

.message {
  font-size: 18px;
  min-height: 50px;
}

.dialog {
  max-width: 300px;
}
</style>
